import { PropsWithChildren } from "react";

import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";
import { getTopicflowIcon } from "@components/topicflow-icon/topicflow-icon-helpers";
import { classNames } from "@helpers/css";

const ModalTitle = ({
  onClose,
  children,
  className,
  buttons,
}: PropsWithChildren<{
  onClose?: () => void;
  className?: string;
  buttons?: React.ReactNode;
}>) => (
  <div
    className={classNames("flex items-center justify-between gap-2", className)}
  >
    <h3 className="flex-1 text-lg leading-6 font-medium text-gray-900">
      {children}
    </h3>
    <div className="empty:hidden flex items-center justify-end gap-2">
      {buttons}
      {onClose && (
        <Button
          icon={getTopicflowIcon("close")}
          onClick={onClose}
          theme={buttonTheme.iconGray}
          aria-label="Close modal button"
        />
      )}
    </div>
  </div>
);

export default ModalTitle;
